import { Controller } from "@hotwired/stimulus"

// Active-state pill swap for the Compare tab's sub-nav. The links
// themselves opt out of Turbo (`data-turbo="false"`) so the browser
// handles native fragment-scroll; this controller only manages the
// visual active-state indicator so the user sees which section the
// click jumped to.
//
// We don't manage the scroll itself — the browser does that natively
// via the `href="#ec-section-X"` fragment. We don't preventDefault().
export default class extends Controller {
  setActive(event) {
    const clicked = event.currentTarget
    if (!clicked) return

    const links = this.element.querySelectorAll("a.nav-link")
    links.forEach((link) => link.classList.toggle("active", link === clicked))
  }
}
